export { default as Home } from './Home';
export { default as Work } from './Work';
export { default as Photo } from './Photo';
export { default as Resume } from './Resume';



// WEBPACK FOOTER //
// ./src/views/index.js